export * from './claim-pictures.component';
